import {generateResidentialConnectionString} from "@/utils/template_utils";

const proxyTemplates = {
    CURL: {
        get: (request_generator, username, password, url) => {
            return `curl --proxytunnel --proxy "https://residential.scrapingant.com" --proxy-user "${generateResidentialConnectionString(request_generator, username, password)}" "${url}"`;
        }
    },
}

const datacenterProxyTemplates = {
    CURL: {
        get: (request_generator, username, password, url) => {
            return `curl --proxytunnel --proxy "https://datacenter.scrapingant.com" --proxy-user "${generateResidentialConnectionString(request_generator, username, password)}" "${url}"`;
        }
    },
}

export {proxyTemplates, datacenterProxyTemplates};
